import { Component, OnInit } from "@angular/core";
import {
	UntypedFormControl,
	UntypedFormGroup,
	Validators
} from "@angular/forms";
import { Router } from "@angular/router";
import { ChangePasswordDTO, UserDTO } from "@shared/model/user.model";
import { UserApiService } from "@shared/services/users/userApi.service";
import { UsersService } from "@shared/services/users/users.service";
import { WcmService } from "@shared/services/wcm/wcm.service";

@Component({
	selector: "app-change-password-logged",
	templateUrl: "./change-password-logged.component.html",
	styleUrl: "./change-password-logged.component.scss",
	standalone: false
})
export class ChangePasswordLoggedComponent implements OnInit {
	changePasswordForm: UntypedFormGroup = new UntypedFormGroup({
		password: new UntypedFormControl("", [
			Validators.required,
			Validators.minLength(8)
		]),
		confPassword: new UntypedFormControl("", [
			Validators.required,
			Validators.minLength(8)
		])
	});

	user: UserDTO;

	constructor(
		private userService: UserApiService,
		private usersService: UsersService,
		private router: Router,
		public wcmService: WcmService
	) { }

	ngOnInit() {
		this.usersService.getProfileOfLoggedUser().subscribe(value => {
			this.user = value;
		});
	}

	changePassword() {
		let dto: ChangePasswordDTO;
		dto = this.changePasswordForm.getRawValue();

		this.userService.changePasswordUsingPOST(dto).subscribe(() => {
			this.router.navigate(["/private"]);
		});
	}

	isValid() {
		const regex = [
			/[a-z]+/g,
			/[A-Z]+/g,
			/[.@"£%$!%*?&/()=^§,.\-_#°\\\|]+/g,
			/[0-9]+/g
		],
			regex1 = [
				/[a-z]+/g,
				/[A-Z]+/g,
				/[.@"£%$!%*?&/()=^§,.\-_#°\\\|]+/g,
				/[0-9]+/g
			],
			pass = this.changePasswordForm.controls["password"].value,
			confPass = this.changePasswordForm.controls["confPassword"].value;

		console.log(pass);
		console.log(confPass);
		// console.log("pass",regex.map(l => l.test(pass)));
		// console.log("confpass",regex1.map(l => l.test(confPass)));
		if (
			regex.map(l => +!!l.test(pass)).filter(value => value).length >= 3 &&
			regex1.map(l => +!!l.test(confPass)).filter(value => value).length >= 3 &&
			pass == confPass
		) {
			console.log(true);
			return true;
		}

		return false;
	}
}
